import {ApiClientCommunication} from 'neo-common';
import {Request} from './Request';
import {GameResponse} from '../Responses/GameResponse';

const action = 'Spin';

/**
 * @class BonusRespinsSpinRequest
 */
export class BonusRespinsSpinRequest extends Request<GameResponse> {
    constructor(customData?: any) {
        super(customData);
    }

    actionName(): string {
        return action;
    }

    createResponse(responseJson: ApiClientCommunication.Types.RawResponseType): GameResponse {
        return new GameResponse(responseJson);
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Requests/BonusRespinsSpinRequest.ts
 **/